import React, { useEffect, useRef, useState } from 'react'
import { EmployerLayout } from '../Layout/EmployerLayout'
import classes from './EmployerJob.module.css'
import { FiEdit } from 'react-icons/fi'
import { Row } from 'react-bootstrap'
import HomeChart from '../Components/HomeChart/HomeChart'
import Nav from '../JobsManager/Tabs/Nav'
import { RouteComponentProps, useHistory } from 'react-router-dom'
import { authAxios } from '../../../API/apiRequest'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import CountCard from '../Components/CountCard/CountCard'
import Applicant from './Applicants/Applicant'
import Rejected from './Rejected/Rejected'
import Interview from './Interview/Interview'
import validator from 'validator'
import { Link } from 'react-router-dom'
import { ACCEPED, PENDING, REJECTED } from '../JobsManager/JobStatus'

export const EmployerJob: React.FC<RouteComponentProps<{id: string}>> = (props) => {
    const [active, setActive] = useState<String>('first')
    const [loading, setLoading] = useState<boolean>(true)
    const [totalSend, setTotalSend] = useState<number>(0)
    const [totalAccept, setTotalAccept] = useState(0)
    const [views, setViews] = useState(0)
    const [totalReject, setTotalReject] = useState(0)
    const [seen, setSeen] = useState<[{id: string, title: string, data: number[]}] | []>([])
    const [applications, setApplications] = useState<[{id: string, title: string, data: number[]}] | []>([])
    const [title, setTitle] = useState('')
    const [dates, setDates] = useState([])
    const [statusColor, setStatusColor] = useState<string>('#184e5d')
    const myRef = useRef<HTMLDivElement>(null)
    const history = useHistory()


    const onClickApplications = ()=>{
        if(myRef.current !== null)
            myRef.current.scrollIntoView({behavior: 'smooth'}) 
    }


    useEffect(()=>{
        
        async function getJobData(){
            try{
              let result = await authAxios.get(`/employer/job/${props.match.params.id}`)
              setTitle(result.data.title)
              setDates(result.data.dates)
              setSeen(result.data.seen)
              setApplications(result.data.applications)
              setTotalAccept(result.data.totalAccept)
              setTotalSend(result.data.totalSend)
              setTotalReject(result.data.totalReject)
              setViews(result.data.views)
              switch(result.data.status){
                case PENDING:
                  setStatusColor('#c18521')
                  break;
                case ACCEPED:
                    setStatusColor('#007d50')
                  break;
                case REJECTED:
                    setStatusColor('rgb(94, 15, 1)')
                  break;
                default:
                    setStatusColor('#184e5d')
            }
            }catch(e: any){
                console.log(e)
                if(e.response && e.response.status === 422)
                    history.replace('/404')

            }
            setLoading(false)
        }
        if(validator.isMongoId(props.match.params.id))
            getJobData()
        else{
            history.replace('/404')
        }

    },[props.match.params.id, history])

    
    const changeActive = (value: String)=>{
        setActive(value)
    }  

    if(loading) return <LoadingEmployerJob/>
    return (
    <EmployerLayout>
            <Row>
                <Link to={`/employer/editjob/${props.match.params.id}`} style={{backgroundColor: statusColor}} className={`col d-flex ${classes.firstRow}`}>
                    <div style={{marginBottom: 10}}>
                        <FiEdit color='#BBBBBB' size={30}/>
                    </div>
                    <h2 className={classes.jobText}>{title}</h2>
                </Link>
            </Row>
            <div className='row mx-0 justify-content-center mt-3' style={{boxSizing: 'border-box'}}>
                <CountCard name='اجمالي المشاهدات' number={views} />
                <CountCard name='إجمالي التقديمات' onClick={onClickApplications} number={totalAccept + totalReject + totalSend} />
              </div>
            <Row className='justify-content-center'>
                <div className='col-md-5'>
                    <HomeChart dates={dates} series={applications} title={'تقديمات'}/>
                </div>
                <div className='col-md-5'>
                    <HomeChart dates={dates} series={seen} title={'مشاهدات'}/>
                </div>
            </Row>
            <Row className='justify-content-center d-flex'>
                <div 
                    ref={myRef}
                    className={'col d-flex m-0 p-0'} 
                    style={{
                        justifyContent: 'center', 
                        alignItems: 'center'
                        }}
                >
                <Nav 
                    totalSend={totalSend}  
                    totalAccept={totalAccept}  
                    totalReject={totalReject}  
                    changeActive={changeActive} 
                    active={active}
                />
                </div>
            </Row>
            {(active === 'first') && 
                <Applicant setTotal={setTotalSend} {...props} />}
                {active === 'center' && 
                <Rejected setTotal={setTotalReject} {...props} />}
                {active === 'last' && 
                <Interview setTotal={setTotalAccept} {...props} />}
          
    </EmployerLayout>)
}


export const LoadingEmployerJob: React.FC = ()=>{
    return(
        <EmployerLayout>
            <SkeletonTheme baseColor="gray" highlightColor="#fff">
            <div className='row mx-0 justify-content-center'>
              <div className='col-md'>
                <div className='col-md justify-content-center m-auto'>
                    <p><Skeleton direction='rtl' height={40} duration={0.8} /></p>
                 </div> 
              </div>
              </div>
            <div className='col'>
                <p style={{textAlign: 'center'}}><Skeleton direction='rtl' duration={0.8} /></p>
            </div>
            <div className='col-md justify-content-center m-auto'>
             <p><Skeleton direction='rtl' height={100} duration={0.8} /></p>
             <p><Skeleton direction='rtl' height={100} duration={0.8} /></p>
            </div>
          </SkeletonTheme>
        </EmployerLayout>
    )
} 
